export default "__VITE_ASSET__PnUc8fTV__"